<template>
  <div class="article_details">
    <div class="content">
      <div class="data_detail" >
        <div class="top_title">
           <!-- 新闻标题 -->
          <div class="title text_one_line">
            {{ passData.title }}
          </div>
          <div @click="goBack()" class="back">
            <div class="back_txt">Back</div>
          </div>
        </div>
        <div class="other_infor">
          <!-- 发布时间，发布媒体，热度排名 -->
          <div class="message">
            <span class="publish_date">{{ passData.publish }}</span>
            <span class="publish_media">Source:{{ passData.source }}（{{passData.countries || 'None'}}）</span>
            <span class="rank" v-if="sameNewsCount">Heat ranking:No.{{topNum}}</span>
            <span class="same" v-if="sameNewsCount">Same news:{{sameNewsCount}}</span>
          </div>
          <!-- 情感 -->
          <div class="judge_btn">
            <span class="show_btn">{{passData.emotionalChineseName}}</span>
          </div>
        </div>
        <!-- 新闻摘要 -->
        <div class="abstract">{{ passData.summary }}</div>
        <!-- 新闻内容 -->
        <div class="detail_txt">
          <div class="paragraph" v-html="passData.content">{{ passData.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emotionDetail } from "@/common/js/http/version3Api.js";
export default {
  mounted() {
    this.getNewsDetail();
  },
  data() {
    return {
      startTime: "",
      endTime: "",
      top: 0,
      topNum: this.$route.query.topNum,
      sameNewsCount: this.$route.query.sameNewsCount,
      passData: {},
    };
  },
  methods: {
    goBack() {
      if(this.$route.query.isBack) {
        this.$router.go(-1)
      }else {
        this.$router.push({
          path: "/brand/BigFrame/logoDetail/Detail/NewsCensus"
        });
      }
    },
    async getNewsDetail() {
      const form = {
        id: this.$route.query.id,
        companyId: this.$route.query.companyId,
        emotion: this.$route.query.emotion,
        site: this.$route.query.site,
        startTime: this.startTime,
        endTime: this.endTime,
        top: this.top
      };
      const res = await emotionDetail(form)
      if(res.code === 200){
        this.passData = res.result
      }
    },
  },
  watch: {
    $route: {
      handler(newValue) {
        // console.log(newValue, '路由信息')
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.back_txt {
  cursor: pointer;
  width: 60px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  color: #8590a6;
  text-align: center;
  background: #f2f3f4;
  border: 1px solid rgba(0, 0, 0, 0);
  font-family: RCR;
}
.content {
  background: #eff0f1;
  /* padding: 15px; */
}
.data_detail {
  background: #fff;
  padding: 24px;
}
.content .title {
  font-size: 20px;
  color: #4e5671;
  font-family: RCB;
}
.other_infor {
  font-size: 12px;
  color: #80828d;
  margin: 16px 0;
  font-family: RCR;
}
.other_infor span {
  margin-right: 20px;
}
.abstract {
  padding: 18px 20px;
  font-size: 14px;
  text-align: justify;
  line-height: 21px;
  background: #e8eaef;
  margin-bottom: 16px;
  font-family: RCR;
  border-radius: 5px;
  color: #4f5362;
}
.paragraph {
  font-size: 18px;
  color: #4e5671;
  text-align: justify;
  line-height: 26px;
  margin-bottom: 30px;
  text-indent: 2em;
  font-family: RCR;
}
.top_title {
  width: 100%;
  display: flex;
}
.top_title .title {
  width: 95%;
  background: #fff;
  word-break: break-all;
}
.top_title .back {
  margin: 0 auto;
  width: 60px;
  height: 30px;
  color: rgba(133, 144, 166, 1);
  background: rgba(242, 243, 244, 1);
  border-radius: 20px;
}
.message {
    width: 80%;
    display: inline-block;
}
.judge_btn {
  display: inline-block;
  text-align: left;
}
.show_btn {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 1px 10px;
  border-radius: 7px;
  font-size: 10px;
}
</style>
